
<div class="modal active coverageAssessment">
  <div class="modal__container" style="width: 50%;">
    <div class="fields">
      <h2>Configuration Menu</h2>
      <div class="close" (click)="cancel8dbBoundary()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Choose Desired NavAid</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Desired NavAid</label>
                  <select required [(ngModel)]="desiredNavaid" name="desiredNavaid" (change)="changeNavaidSelected()">
                    <option
                    *ngFor=" let navaidSelected of navaidsCoChannelService.previousSelectedNavaids" [ngValue]="navaidSelected" >
                      {{navaidSelected.navaidid}}_{{navaidSelected.icaocc}}_{{navaidSelected.navaidtype}}
                    </option>
                  </select>
                </div>
              </div>
              <label for="">Undesired NavAid</label>
              <p> {{undesiredNavaid.navaidid}}_{{undesiredNavaid.icaocc}}_{{undesiredNavaid.navaidtype}} </p>
              <div class="input-fields">
                <div>
                  <input
                    type="checkbox"
                    id="drawBoth"
                    name="drawBoth"
                    [(ngModel)]="drawBoth"
                  />
                  <label for="drawBothCheckbox">Draw both boundaries</label>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Fix NavAid's EIRP</h4>
              <span> </span>
              </div>
              <div class="input-fields">
                <ng-container *ngFor=" let navaidSelected of navaidsCoChannelService.previousSelectedNavaids; let i = index">
                  <div>
                    <label for="">{{navaidSelected.navaidid}}_{{navaidSelected.icaocc}}_{{navaidSelected.navaidtype}}:</label>
                    <input id="Navaid{{i}}EIRP" name="Navaid{{i}}EIRP" type="number" [(ngModel)]="NavaidsEIRP[i]" [required]="true"/><span>[dBW]</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button class="blue" (click)="performBoundary()">
              Ok
            </button>
            <button class="gray" (click)="cancel8dbBoundary()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

